export const colors = {
    primary: '#004632',
    cta: '#2E7D32',
    white: '#ffffff',
    black: '#000000',
    gray: '#F7F7F7',
    lightGray: '#DCDCDC',
    orange:'#EB7100',
    // 金卡淺底：用實色（非漸層）避免 html2canvas PDF 截圖出現色帶
    goldTint: '#E8F0EB',
    // 分隔線色（比 lightGray 再淡一階，雜誌型 V3 用）
    divider: '#EAEAEA',
    // 次要文字（英文小標、輔助說明）
    muted: '#8A8A8A',
    // ── 可讀性升級 token（集中管理 hover / 斑馬底色）──
    // 整支豆斑馬底色（綠灰，呼應品牌，與白底灰階差可感知）
    zebra: '#F2F4F2',
    // row-hover 行追蹤底色（壓過斑馬）
    rowHover: '#eef3f0',
    // 金卡交叉處 hover（hover 優先於金卡底色，較金卡底再深一階）
    rowHoverGold: '#e0ebe4'
  };

  // 三版共用的字級常數（單一概念用底線）
  export const fontSizes = {
    badge: '11px',
    label: '12px',
    body: '13px',
    title: '16px',
    title_large: '20px',
    price: '15px',
    price_large: '22px',
    hero_title: '26px',
    hero_desc: '15px'
  };

 const breakpoints = {
    mobile: '768px',
    tablet: '1280px',
    desktop: '1440px',
  };

  export const mediaQueries = {
    mobile: `@media (max-width: ${breakpoints.mobile})`,
    tablet: `@media (max-width: ${breakpoints.tablet})`,
    desktop: `@media (min-width: ${breakpoints.desktop})`,
  };